import VCenteredContainer from '../components/containers/VCenteredContainer';
const Page403 = () => {
  return (
    <VCenteredContainer>
      <div className="flex flex-col items-center justify-center">
        <h1 className="text-6xl font-bold text-red-500">Acesso não autorizado</h1>
        <p className="mt-4 text-lg text-gray-700">Você não tem permissão para acessar esta página.</p>
        <p className="mt-2 text-lg text-gray-700">Caso tenha alguma dúvida, entre em contato com o administrador do sistema.</p>
      </div>
    </VCenteredContainer>
  );
}
export default Page403;